// aws-config-joborder-receipts.js
import AWS from 'aws-sdk';

const ACCOMPLISHMENT_BUCKET_NAME = 'boaz-accomplishment-images';

const s3AccomplishmentImageUploader = new AWS.S3({
  accessKeyId: 'AKIAVXGA6A4K2B4PD2K2', // Replace with the new user's Access Key ID
  secretAccessKey: 'oEUt4jIzOMgmdJV2l+wLkeonf+n62sjVjDZ5RBAH', // Replace with the new user's Secret Access Key
  region: 'ap-southeast-1' // Replace with your S3 bucket's region
});

export { s3AccomplishmentImageUploader, ACCOMPLISHMENT_BUCKET_NAME};
